module.exports = __webpack_public_path__ + "static/img/video.d884510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/video.png
// module id = rSeC
// module chunks = 1